import axios from 'axios';

import { MODEL_API_ROOTS } from '@/store/api';

export const ACTOR_ID_HEADER = 'X-Valur-Actor-Id';
export const ACTOR_TYPE_HEADER = 'X-Valur-Actor-Type';
export const ACTOR_FIRM_HEADER = 'X-Valur-Actor-Firm';
export const ACTOR_ROLE_HEADER = 'X-Valur-Actor-Role';
export const ACTOR_ON_BEHALF_OF_HEADER = 'X-Valur-Actor-On-Behalf-Of';

export const ACTOR_TYPE_ANONYMOUS = 'anonymous';
export const ACTOR_TYPE_CLIENT = 'client';
export const ACTOR_TYPE_ADVISOR = 'advisor';
export const ACTOR_TYPE_STAFF = 'staff';

function advisorRoleOf(user) {
    return (user.advisor_workspace || {}).role || null;
}

function onBehalfOf(store) {
    const impersonated = store.state.impersonatedUser;
    if (impersonated && (impersonated.uuid || impersonated.id)) {
        return impersonated.uuid || String(impersonated.id);
    }
    try {
        return new URLSearchParams(window.location.search).get('client_id') || null;
    } catch (error) {
        return null;
    }
}

export function resolveActor(store) {
    const user = (store.state.auth || {}).user || {};
    if (!user.id) {
        return {
            id: null,
            type: ACTOR_TYPE_ANONYMOUS,
            firmId: null,
            role: null,
            onBehalfOf: null,
        };
    }

    const advisorRole = advisorRoleOf(user);
    let type = ACTOR_TYPE_CLIENT;
    if (user.is_staff || user.is_superuser) {
        type = ACTOR_TYPE_STAFF;
    } else if (user.is_advisor || advisorRole) {
        type = ACTOR_TYPE_ADVISOR;
    }

    return {
        id: user.uuid || String(user.id),
        type,
        firmId: (user.advisor_workspace || {}).uuid || null,
        role: advisorRole,
        onBehalfOf: onBehalfOf(store),
    };
}

function originOf(url) {
    try {
        return new URL(url, window.location.href).origin;
    } catch (error) {
        return null;
    }
}

const MODEL_ORIGINS = new Set(MODEL_API_ROOTS.map(originOf).filter(Boolean));

function isModelRequest(url) {
    if (!url) return false;
    if (MODEL_API_ROOTS.some(root => url.startsWith(root))) return true;
    const origin = originOf(url);
    if (!origin || !MODEL_ORIGINS.has(origin)) return false;
    return new URL(url, window.location.href).pathname.includes('/calculate');
}

export function installCalculatorActorHeaders(store) {
    return axios.interceptors.request.use(config => {
        if (!isModelRequest(config.url)) {
            return config;
        }

        const actor = resolveActor(store);
        config.headers = config.headers || {};
        config.headers[ACTOR_TYPE_HEADER] = actor.type;
        if (actor.id) {
            config.headers[ACTOR_ID_HEADER] = actor.id;
        }
        if (actor.firmId) {
            config.headers[ACTOR_FIRM_HEADER] = actor.firmId;
        }
        if (actor.role) {
            config.headers[ACTOR_ROLE_HEADER] = actor.role;
        }
        if (actor.onBehalfOf) {
            config.headers[ACTOR_ON_BEHALF_OF_HEADER] = actor.onBehalfOf;
        }
        return config;
    });
}
